import { render, staticRenderFns } from "./ResellersRow.vue?vue&type=template&id=bfe161b6"
import script from "./ResellersRow.vue?vue&type=script&lang=js"
export * from "./ResellersRow.vue?vue&type=script&lang=js"
import style0 from "./ResellersRow.vue?vue&type=style&index=0&id=bfe161b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports